import React, {Component} from 'react'
import {Progress, Modal, Button,message,Alert,Spin} from 'antd';
import './oa.less'
const  locationQuery = new URLSearchParams(window.location.search)
class RegularLetter extends Component {
    state = {

        name:locationQuery.get('name')||'',
        date:locationQuery.get('date')||'',
    }
    componentDidMount(){

    }
    render() {
        return (
            <div className={'regular-letter'}>
                <div className={'regular-letter-wrap'}>
                    <span className={'icon'}></span>
                    <div className={'regular-letter-content'}>
                        <h3>【系统公告】您已获得转正通关纪念卡</h3>
                        <h4>Dear {this.state.name}：</h4>
                        <p>恭喜你顺利转正通关！在「小鲜奶旅程」里，你以超A级表现成功突围！</p>
                        <p>滴！从今天起，你正式解锁「乐纯正式伙伴」身份卡！</p>
                        <p>转正只是新手村毕业礼，真正的大BOSS副本才刚刚加载完毕！准备好和我们一起打怪升级了吗？</p>
                        <p>谢谢你带来的满格能量和超凡脑洞！</p>
                        <p>让我们一起不断超越自我、共同成长，为平凡生活创造幸福体验！</p>
                        <div className={'regular-letter-footer'}>
                            人力资源部<br/>
                            {this.state.date}
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}

export default RegularLetter
